import slotConverter from 'models/Slot/converter'
import getCollectionByName from 'actions/base/getCollectionByName'

const getCollection = (withConverter = true) => getCollectionByName('slots', withConverter ? slotConverter : null)

export default getCollection
